import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Cloud, Server, Shield, Globe } from 'lucide-react';
import clsx from 'clsx';


export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col font-sans text-slate-900">
      <nav
        className="fixed w-full z-50 transition-all duration-300 py-4 bg-slate-900 text-white shadow-md"
      >
        <div className="container mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-2xl font-bold tracking-tighter">
            <Cloud className="w-8 h-8 text-blue-500" />
            <span className="text-white">HelsinkiDC.com</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8 font-medium">
            <Link to="/" className="hover:text-blue-400 transition-colors">Etusivu</Link>
            <Link to="/datacenter" className="hover:text-blue-400 transition-colors">Data Center</Link>
            <Link to="/services" className="hover:text-blue-400 transition-colors">Palvelut</Link>
            <Link to="/about" className="hover:text-blue-400 transition-colors">Ajankohtaista</Link>
            <Link to="/contact" className="hover:text-blue-400 transition-colors">Ota yhteyttä</Link>
            <Link to="/english" className="hover:text-blue-400 transition-colors">In English</Link>

            <button 
              onClick={() => alert("Ole hyvä ja pyydä asiakasportaalin tiedot yhteyshenkilöltäsi!")}
              className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-700 transition-colors"
            >
              Login
            </button>
          </div>

          {/* Mobile Toggle */}
          <button 
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-slate-900 shadow-lg py-4 px-6 flex flex-col gap-4 md:hidden text-white border-t border-slate-800">
            <Link to="/" className="py-2 border-b border-slate-800">Etusivu</Link>
            <Link to="/datacenter" className="py-2 border-b border-slate-800">Data Center</Link>
            <Link to="/services" className="py-2 border-b border-slate-800">Palvelut</Link>
            <Link to="/about" className="py-2 border-b border-slate-800">Ajankohtaista</Link>
            <Link to="/contact" className="py-2 border-b border-slate-800">Ota yhteyttä</Link>
            <Link to="/english" className="py-2 border-b border-slate-800">In English</Link>

            <button 
              onClick={() => alert("Client Portal is coming soon!")}
              className="bg-blue-600 text-white px-5 py-2 rounded-full w-full"
            >
              Login
            </button>
          </div>
        )}
      </nav>
      <main className="flex-grow">
        {children}
      </main>
      <footer className="bg-slate-900 text-slate-300 py-12">
        <div className="container mx-auto px-6 grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 text-2xl font-bold text-white mb-4">
              <Cloud className="w-6 h-6 text-blue-500" />
              <span>HelsinkiDC.com</span>
            </div>
            <p className="text-sm leading-relaxed">
              HelsinkiDc.com - Kotimainen, kyberturvallinen ja suvereeni infra
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Palvelut</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-white">Colocation</Link></li>
              <li><Link to="/services" className="hover:text-white">Private Cloud</Link></li>
              <li><Link to="/services" className="hover:text-white">Baremetal</Link></li>
              <li><Link to="/services" className="hover:text-white">Kyberturvallisuus</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Yritys</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white">Ajankohtaista</Link></li>
              <li><Link to="/contact" className="hover:text-white">Yhteystiedot</Link></li>
              <li><Link to="/english" className="hover:text-white">Briefly In English</Link></li>

            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Ota yhteyttä!</h3>
            <ul className="space-y-2 text-sm">
              <li>Hiomotie 32, 00380 Helsinki, Finland</li>
              <li>sales@helsinkidc.com</li>
              <li>+358 10 8433700</li>
            </ul>
          </div>
        </div>
        <div className="container mx-auto px-6 mt-12 pt-8 border-t border-slate-800 text-center text-xs">
          © {new Date().getFullYear()} HelsinkiDC.com. All rights reserved.</div>
      </footer>
    </div>
  );
};
